
export class QuestionFile {
  public fileName: string;
  public fileData: string;
}



// WEBPACK FOOTER //
// ./src/app/models/QuestionFile.ts